// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as TestUtils$OrcaPaymentPage from "../Utilities/TestUtils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../Utilities/DynamicFieldsUtils.bs.js";

function FullNamePaymentInput(props) {
  var __optionalRequiredFields = props.optionalRequiredFields;
  var __customFieldName = props.customFieldName;
  var customFieldName = __customFieldName !== undefined ? Caml_option.valFromOption(__customFieldName) : undefined;
  var optionalRequiredFields = __optionalRequiredFields !== undefined ? Caml_option.valFromOption(__optionalRequiredFields) : undefined;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userFullName);
  var setFullName = match$2[1];
  var fullName = match$2[0];
  var showDetails = PaymentType$OrcaPaymentPage.getShowDetails(match$1.fields.billingDetails);
  var changeName = function (ev) {
    var val = ev.target.value;
    setFullName(function (prev) {
          return Utils$OrcaPaymentPage.validateName(val, prev, localeString);
        });
  };
  var onBlur = function (ev) {
    var val = ev.target.value;
    setFullName(function (prev) {
          return Utils$OrcaPaymentPage.validateName(val, prev, localeString);
        });
  };
  var match$3 = customFieldName !== undefined ? [
      customFieldName,
      customFieldName
    ] : [
      localeString.fullNamePlaceholder,
      localeString.fullNameLabel
    ];
  var fieldName = match$3[1];
  var nameRef = React.useRef(null);
  React.useEffect((function () {
          setFullName(function (prev) {
                return Utils$OrcaPaymentPage.validateName(prev.value, prev, localeString);
              });
        }), []);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit) {
            if (fullName.value === "") {
              return setFullName(function (prev) {
                          var newrecord = Caml_obj.obj_dup(prev);
                          newrecord.errorString = localeString.nameEmptyText(fieldName);
                          return newrecord;
                        });
            } else if (Core__Option.getOr(fullName.isValid, false)) {
              if (optionalRequiredFields !== undefined && !DynamicFieldsUtils$OrcaPaymentPage.checkIfNameIsValid(optionalRequiredFields, "FullName", fullName)) {
                return setFullName(function (prev) {
                            var newrecord = Caml_obj.obj_dup(prev);
                            newrecord.errorString = localeString.completeNameEmptyText(fieldName);
                            return newrecord;
                          });
              } else {
                return ;
              }
            } else {
              return setFullName(function (prev) {
                          var newrecord = Caml_obj.obj_dup(prev);
                          newrecord.errorString = localeString.invalidCardHolderNameError;
                          return newrecord;
                        });
            }
          }
          
        }), [fullName]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: showDetails.name === "Auto",
              children: React.createElement(PaymentField$OrcaPaymentPage.make, {
                    setValue: setFullName,
                    value: fullName,
                    onChange: changeName,
                    onBlur: onBlur,
                    fieldName: fieldName,
                    name: TestUtils$OrcaPaymentPage.fullNameInputTestId,
                    type_: "text",
                    placeholder: match$3[0],
                    inputRef: nameRef
                  })
            });
}

var make = FullNamePaymentInput;

export {
  make ,
}
/* react Not a pure module */
